export default __webpack_public_path__ + "static/media/9f0d18959f3261383ea822941351c327.svg";